import closeCompose from './closeCompose';
import composeStore from '../store/composeStore';
import floatCompose from './floatCompose';
import pendCompose from './pendCompose';
import removeInfoBarMessage from './removeInfoBarMessage';
import { findTabByData, lazySetTabIsShown } from 'owa-tab-store';
import { action, select } from 'satcheljs/lib/legacy';
import isTabViewEnabled from 'owa-tab-store/lib/utils/isTabViewEnabled';
import { sendAndSaveInfobarIdsToRemove } from '../utils/InfoBarMessageId';
import endSession from 'owa-controls-findpeople-feedback-manager/lib/actions/endSession';
var ASYNC_SEND_WAITING_TIME = 10000;
var ASYNC_SENT_DISMISS_TIME = 3000;
var setAsyncSendState = action('setAsyncSendState')(select({
    pendingViewState: function () { return composeStore.pendingViewState; },
    floatingViewStates: function () { return composeStore.floatingViewStates; },
})(function (viewState, asyncSendState, state) {
    if (viewState.changeAsyncSendStateTimer) {
        window.clearTimeout(viewState.changeAsyncSendStateTimer);
        viewState.changeAsyncSendStateTimer = 0;
    }
    viewState.asyncSendState = asyncSendState;
    if (isTabViewEnabled()) {
        var tab = findTabByData(viewState);
        switch (asyncSendState) {
            case 1 /* Sending */:
                if (tab) {
                    lazySetTabIsShown.importAndExecute(tab, false /*isShown*/);
                }
                viewState.changeAsyncSendStateTimer = window.setTimeout(function () {
                    setAsyncSendState(viewState, 3 /* Timeout */);
                }, ASYNC_SEND_WAITING_TIME);
                break;
            case 4 /* Sent */:
                removeInfoBarMessage(viewState, sendAndSaveInfobarIdsToRemove);
                viewState.changeAsyncSendStateTimer = window.setTimeout(function () {
                    setAsyncSendState(viewState, 5 /* Closed */);
                }, ASYNC_SENT_DISMISS_TIME);
                break;
            case 5 /* Closed */:
                endSession(viewState.findPeopleFeedbackManager, 'Send');
                closeCompose(viewState);
                break;
            case 3 /* Timeout */:
                if (tab) {
                    lazySetTabIsShown.importAndExecute(tab, true /*isShown*/);
                }
                break;
        }
    }
    else {
        // TODO: remove this part once we fully enable tab View
        switch (asyncSendState) {
            case 1 /* Sending */:
                pendCompose();
                viewState.changeAsyncSendStateTimer = window.setTimeout(function () {
                    setAsyncSendState(viewState, 3 /* Timeout */);
                }, ASYNC_SEND_WAITING_TIME);
                break;
            case 4 /* Sent */:
                removeInfoBarMessage(viewState, sendAndSaveInfobarIdsToRemove);
                if (state.pendingViewState == viewState) {
                    // If we haven't show the toast yet, just let it close silently
                    setAsyncSendState(viewState, 5 /* Closed */);
                }
                else {
                    // Otherwise, show message sent toast and dismiss in 3s if it is still minimized
                    var floatingViewState = state.floatingViewStates.get(viewState.composeId);
                    if (floatingViewState && floatingViewState.type == 1 /* Minimized */) {
                        viewState.changeAsyncSendStateTimer = window.setTimeout(function () {
                            setAsyncSendState(viewState, 5 /* Closed */);
                        }, ASYNC_SENT_DISMISS_TIME);
                    }
                }
                break;
            case 5 /* Closed */:
                closeCompose(viewState);
                break;
            case 3 /* Timeout */:
                floatCompose(viewState, 1 /* Minimized */);
                break;
        }
    }
}));
export default setAsyncSendState;
//# sourceMappingURL=setAsyncSendState.js.map